import { SOCIAL_MEDIA_TYPES } from '../../../constants/admin/settings';
import { pick, filter, uniq } from 'lodash';
import { ADDRESS_FIELDS } from '../../../constants/admin/settings';
import { bufferArrayToUtf8 } from '../../../lib/string.utils';

export const stateToApiData = (data, isCreate = false) => {
    const bodyData = {
        ...data,
        socialMedia: filter(data.socialMedia, sm => sm.v)
    };
    const addressFields = Object.keys(ADDRESS_FIELDS);
    const body = pick(
        bodyData,
        [
            'name',
            'organizationIds',
            'eventIds',
            'timeZone',
            'socialMedia',
            'website',
            'description',
            'image',
            'category'
        ].concat(isCreate ? addressFields : addressFields.concat(['id']))
    );
    body.eventIds = uniq(body.eventIds || []);
    body.organizationIds = uniq(body.organizationIds || []);
    return body;
};

export const apiDataToState = data => {
    data.socialMedia = (data.socialMedia || []).concat([{ k: SOCIAL_MEDIA_TYPES[0], v: '' }]);
    data.image = bufferArrayToUtf8((data.image && data.image.data) || []);
    data.organizationIds = data.organizationIds || [];
    return data;
};
